import { OrderStatus } from "@repo/shopify/src/utils/order";
import type { OrderEdge } from "@shopify/hydrogen-react/storefront-api-types";

import { OrderStatus as OrderState, StatusColor } from "@const/enum";

/** 취소된 주문을 제외한 모든 경우의 주문을 필터링 */
export const getValidOrders = (orders: OrderEdge[]) => {
  const currentYear = new Date().getFullYear().toString();
  return orders.filter(({ node }) => {
    const isCanceled = node.financialStatus === OrderState.Refunded && node.canceledAt;
    return node.processedAt.startsWith(currentYear) && !isCanceled;
  });
};

/** 주문 상태에 다른 statusColor를 반환해주는 함수 */
export const getStatusColor = (OrderStatusText: OrderStatus) => {
  switch (OrderStatusText) {
    // 결제 완료, 주문 완료, 발송 완료, 환불 완료, 발송 완료, 일부 발송 완료, 예약 발송 완료, 응모 완료
    case OrderStatus.Paid:
    case OrderStatus.Completed:
    case OrderStatus.Fulfilled:
    case OrderStatus.Refunded:
    case OrderStatus.Shipped:
    case OrderStatus.Partially_Shipped:
    case OrderStatus.Completed_Preparing:
    case OrderStatus.DrawApply:
      return StatusColor.Processing; // 환불 완료

    // 주문 취소, 당첨 취소, 응모 취소, 미당첨
    case OrderStatus.Canceled:
    case OrderStatus.PrizeCancel:
    case OrderStatus.DrawCancel:
    case OrderStatus.DrawLose:
      return StatusColor.Error;

    // 미발송, 부분 환불됨, 반품 접수됨, 반품 승인됨, 배송 준비 중, 예약 발송 준비 중
    case OrderStatus.Unfulfilled:
    case OrderStatus.Partially:
    case OrderStatus.Return_Requested:
    case OrderStatus.Return_Approved:
    case OrderStatus.Preparing:
    case OrderStatus.Scheduled_Preparing:
      return StatusColor.Pending;

    // 당첨 🎉
    case OrderStatus.DrawWin:
      return StatusColor.Finished;

    default:
      return StatusColor.Processing;
  }
};
